var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitutionDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#FDFDFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 7,
    height: 16,
    rx: 1,
    fill: "#8CA1B4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 7,
    height: 16,
    rx: 1,
    fill: "#8CA1B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7C12.4477 7 12 7.44772 12 8V26C12 26.5523 12.4477 27 13 27H19C19.5523 27 20 26.5523 20 26V8C20 7.44772 19.5523 7 19 7H13ZM16.765 13.7062H15.3332V12.057H13.6841V10.6252H15.3332V8.97607H16.765V10.6252H18.4142V12.057H16.765V13.7062Z",
    fill: "#8CA1B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionDefault);
export default __webpack_public_path__ + "static/media/institution-default.9f8b64e2056dd67cdc5f154dd6580ded.svg";
export { ForwardRef as ReactComponent };